export default __webpack_public_path__ + "static/media/left-arrow.2d863411.svg";